import { useContext } from "react";

import { FeatureFlagsContext } from "./feature-flags-context";

export function useIntegratorSyncEnabled(): boolean {
  return useContext(FeatureFlagsContext).integratorSyncEnabled;
}

/** Slice 11 live credential flow. False when LaunchDarkly is on and the flag is off or missing. */
export function useLiveCredentialsEnabled(): boolean {
  return useContext(FeatureFlagsContext).liveCredentialsEnabled;
}

/** False while LaunchDarkly still evaluates flags for the current identity. */
export function useFeatureFlagsResolved(): boolean {
  return useContext(FeatureFlagsContext).flagsResolved;
}
